// ===== Monthly Target =====
export const CONFIRMED_GET_MONTHLY_TARGET = "CONFIRMED_GET_MONTHLY_TARGET";
export const CONFIRMED_SAVE_MONTHLY_TARGET = "CONFIRMED_SAVE_MONTHLY_TARGET";
export const CONFIRMED_DELETE_MONTHLY_TARGET = "CONFIRMED_DELETE_MONTHLY_TARGET";
